import React from "react";
import { FeatureCard } from "./FeatureCard";
import AI from "../../../img/upgrade/ai-image.jpg";
import AIMobile from "../../../img/upgrade/AI-mobile.jpg";
import Orch from "../../../img/upgrade/data-orch.jpg";
import OrchMobile from "../../../img/upgrade/orch-mobile.jpg";
import Cloud from "../../../img/upgrade/cloud.jpg";
import CloudMobile from "../../../img/upgrade/cloud-mobile.jpg";

export function WhyUpgrade() {
    return (
        <div className="why-upgrade d-flex flex-column flex-xxl-row gap-5 gap-xxl-6">
                <div className="left-column vstack">
                <span className="eyebrow">Why upgrade</span>
                <h2 className="heading-black">Stay current <br className="d-none d-xxl-block"/>with RavenDB</h2>
                    <a
                        href="https://ravendb.net/why-ravendb/whats-new"
                        className="btn btn-primary rounded-pill text-white d-flex align-items-center align-self-start gap-2"
                    >
                        <span>Learn more</span>
                    </a>
                </div>
                <div className="vstack gap-3">
                    <FeatureCard 
                        title="Built-in AI capabilities"
                        description="Access RavenDB’s native support for vector search, GenAI integrations, and AI-driven workflows. Designed to run reliably in production environments."
                        imgSrc={AI}
                        imgSrcMobile={AIMobile}
                    />
                    <FeatureCard 
                        title="Optimized engine features"
                        description="Ensure your license fully supports the latest RavenDB engine improvements, including performance optimizations, clustering enhancements, and operational tooling."
                        imgSrc={Orch}
                        imgSrcMobile={OrchMobile}
                    />
                    <FeatureCard 
                        title="Cloud-scale readiness"
                        description="Unlock support for modern cloud and distributed architectures, including improved sharding, scalability, and high-availability capabilities."
                        imgSrc={Cloud}
                        imgSrcMobile={CloudMobile}
                    />
                </div>
            </div>
    );
};
